export default __webpack_public_path__ + "ce505a6c55a1ff63bd9f0b16a69d2824.svg";